//@flow
import React, { useEffect, useState } from "react";
import { Container } from "flux/utils";
import fluxfix from "../../services/fluxfix";
// import Heading from "./../heading";
// import PlayerActions from "../audioplayer-v2/playerControl";
// import { AudioSource, SourceType } from "../audioplayer-v2/source";
import Carousel, { consts } from "react-elastic-carousel";
// $FlowFixMe
import css from "./stations.module.scss";
import Store from "../../services/store";
import Menu from "../menu";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faPlay, faPause, faSyncAlt } from "@fortawesome/free-solid-svg-icons";
import { useQuery, gql } from "@apollo/client";
import Circles from "../circles";

import Station from "./station";

const QUERY_STATIONS = gql`
  query GetStations {
    stations(brandID: "IDR") {
      id
      name
      secret
      online
      shortDescription
      hlsURL
      stationID
      headerImage
      logoSq
      logoHz
      sortOrder
      colour: themeColour
      nowFeature {
        id
        displayNowPlaying
        name
        description
        image
        sponsor {
          id
          url
          image
          name
          text
        }
      }
      nowSong {
        title
        artistDisplay
        artists {
          id
          image
        }
      }
    }
  }
`;

const SUBSCRIBE_STATIONS = gql`
  subscription subscribeStations {
    stations(brandID: "IDR") {
      id
      name
      # secret
      # online
      # shortDescription
      # hlsURL
      stationID
      # headerImage
      # logoSq
      # sortOrder
      # colour: themeColour
      nowFeature {
        id
        displayNowPlaying
        name
        description
        image
        sponsor {
          id
          url
          image
          name
          text
        }
      }
      nowSong {
        title
        artistDisplay
        artists {
          id
          image
        }
      }
    }
  }
`;
type Props = { betaMode: boolean };
type State = {
  Store: Object,
};
class StationsContainer extends React.Component<Props, State> {
  constructor(props: Object) {
    super(props);
    this.state = { Store: {} };
  }
  static getStores() {
    return [Store];
  }

  static calculateState(prevState) {
    return { Store: Store.getState() };
  }

  render() {
    // const stations = this.state.Store && this.state.Store.get("stations");
    // if (!stations) return null;

    const playState = this.state.Store.get("playState");
    const currentMedia = this.state.Store.get("currentSrc")?.src;

    return (
      <Stations
        playState={playState}
        currentMedia={currentMedia}
        betaMode={this.props.betaMode}
      />
    );
  }
}
export default (Container.create(fluxfix.convert(StationsContainer)): Object);

const Stations = (props: {
  betaMode: boolean,
  playState: string,
  currentMedia: Object,
}): Object => {
  const { loading, error, data, subscribeToMore } = useQuery(QUERY_STATIONS);
  const [stationIndex, setStationIndex] = useState(0);
  useEffect(() => {
    subscribeToMore({
      document: SUBSCRIBE_STATIONS,
      variables: {},
      updateQuery: (prev, { subscriptionData }) => {
        const n = { ...prev };
        n.stations = prev.stations?.map((s) => {
          if (s.stationID === subscriptionData?.data?.stations[0]?.stationID) {
            console.log(
              "Station updated: ",
              s.name,
              " Now playing: ",
              subscriptionData?.data?.stations[0]?.nowSong?.title
            );
            return Object.assign({}, s, subscriptionData?.data?.stations[0]);
          }
          return s;
        });
        return n;
      },
    });
  }, [subscribeToMore]);

  // HARDCODED STATION INDEXES MAPPED TO URL PARAM
  const pathname = window.location.pathname;
  // console.log("PN",pathname)
  // const urlParams = new URLSearchParams(queryString);
  // const targetStation = urlParams.get("station");
  const initialIndex = pathname.includes("decades")
    ? 1
    : pathname.includes("workout")
    ? 2
    : 0;

  if (loading) return null;
  if (error) {
    console.error(error);
    return null;
  }

  const { currentMedia, playState, betaMode } = props;
  const stations = data.stations
    ?.filter((a: Object) => a.secret === false)
    .sort((a: Object, b: Object) => {
      return a.sortOrder - b.sortOrder;
    })
    .map((s_: Object, i: number) => {
      const isCurrentMedia = currentMedia === s_.hlsURL;
      return (
        <Station
          key={s_.stationID}
          station={s_}
          playState={playState}
          isCurrentMedia={isCurrentMedia}
        />
      );
    });

  return (
    <div className={css.stations}>
      <Circles colour={data.stations[stationIndex].colour} />
      <Menu />

      <Carousel
        enableSwipe={false}
        enableMouseSwipe={false}
        itemPadding={[0, 10]}
        itemsToShow={1}
        outerSpacing={0}
        renderArrow={myArrow}
        initialActiveIndex={initialIndex}
        onChange={(e) => {
          setStationIndex(e.index);
        }}
      >
        {stations}
      </Carousel>
    </div>
  );
};

const myArrow = ({ type, onClick, isEdge }) => {
  const pointer = type === consts.PREV ? "<" : ">";
  return (
    <div
      onClick={onClick}
      className={[
        css.arrowWrapper,
        type === consts.PREV ? css.arrowWrapperLeft : css.arrowWrapperRight,
        isEdge ? css.disabled : null,
      ].join(" ")}
    >
      <div
        className={[
          css.arrow,
          type === consts.PREV ? css.arrowLeft : css.arrowRight,
        ].join(" ")}
      >
        <div className={css.inner}>{pointer}</div>
      </div>
    </div>
  );
};
